const cache = new Map();

/**
 * Simple JavaScript Templates
 * 
 * Original Source: https://johnresig.com/blog/javascript-micro-templating
 * 
 * Be careful, in some cases you **MUST** add semicolon to your js in template,
 * for example:
 * 
 * ```html
 * <% [].forEach((item) => { %>
 * // . . .
 * <% }); %>
 *```
 * 
 * Another bottleneck is: sometimes you **MUST** escape single quotes in html
 * 
 * ```html
 * <p>I\'m The Title</p>
 * ``` 
 * 
 * @param {string} template template string (*not any selector*)
 * @param {object} data 
 * 
 * @returns string
 */
export default function microTemplate(template, data = {}) {
   if (cache.has(template)) {
      return cache.get(template)(data);
   }

   const parsed = template
      .replace(/[\r\t\n]/g, ' ')
      .split('<%').join('\t')
      .replace(/((^|%>)[^\t]*)'/g, '$1\r')
      .replace(/\t=(.*?)%>/g, "',$1,'")
      .split('\t').join("');")
      .split('%>').join("p.push('")
      .split('\r').join("\\'");

   const fn = new Function('obj',
      `let p=[];with(obj){p.push('${parsed}')};return p.join('');`,
   );
   
   cache.set(template, fn);
   return fn(data);
}